import {niceCount} from '../../lib/formats.js'

const formattedReferences = (formula) => {
  const values = formula.attributes.referencedValues.length
  const formulas = formula.attributes.referencedFormulas.length
  if (!values && !formulas) return 'No dependencies'
  let output = []
  if (values > 0) output.push(niceCount(values, 'value', 'values'))
  if (formulas > 0) output.push(niceCount(formulas, 'formula', 'formulas'))
  return output.join(', ')
}

export default formattedReferences



// WEBPACK FOOTER //
// ./src/components/Formulas/formattedReferences.js